import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";

import Card from "./Card";
import QuizCard from "./QuizCard";
// import quizData from "../data/quizData";
import quizData from '../components/data/quizData'

function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

export default function Feed({ containerRef, onScroll, classes }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [votes, setVotes] = useState({});
  const [readItems, setReadItems] = useState({});
  const [quizSkipped, setQuizSkipped] = useState(false);
  const itemRefs = useRef([]);
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("readItems") || "{}");
    setReadItems(stored);
  }, []);

  useEffect(() => {
    const quizSkipStatus = sessionStorage.getItem("quizSkipped") === "true";
    setQuizSkipped(quizSkipStatus);

    const urlParams = new URLSearchParams(window.location.search);
    const focusId = urlParams.get("id");

    fetch("https://fetchrss.visiontrek.io/api/items")
      .then((r) => r.json())
      .then((data) =>
        Promise.all(
          data.map(
            (item) =>
              new Promise((res) => {
                const img = new Image();
                const src =
                  item.enclosure?.[1]?.href ||
                  item.enclosure?.[0]?.href ||
                  (() => {
                    const cleanSummary = (item.summary || "").replace(
                      /<a[^>]+><\/a>/gi,
                      ""
                    );
                    return (
                      (cleanSummary.match(/<img[^>]+src=["']([^"']+)["']/i) ||
                        [])[1] || ""
                    );
                  })();
                if (!src) return res(item);
                img.onload = () => res(item);
                img.onerror = () => res(null);
                img.src = src;
              })
          )
        ).then((arr) => {
          const newsItems = arr.filter(Boolean);

          // Move shared item to top if exists
          if (focusId) {
            const found = newsItems.find((item) => item.id === focusId);
            if (found) {
              newsItems.splice(newsItems.indexOf(found), 1);
              newsItems.unshift(found);
            }
          }

          const mergedItems = [];
          let quizIndex = 0;
          const shuffledQuiz = shuffleArray(quizData);

          for (let i = 0; i < newsItems.length; i++) {
            mergedItems.push({ type: "card", data: newsItems[i] });

            if (
              !quizSkipStatus &&
              (i + 1) % 4 === 0 &&
              i >= 3 &&
              quizIndex < shuffledQuiz.length
            ) {
              mergedItems.push({
                type: "quiz",
                data: { ...shuffledQuiz[quizIndex], id: `quiz-${quizIndex}` },
              });
              quizIndex++;
            }
          }

          // setItems(mergedItems);
          setItems(mergedItems);
itemRefs.current = mergedItems.map((_, i) => itemRefs.current[i] ?? React.createRef()); // ⬅️ set refs
setLoading(false);

          setLoading(false);
        })
      )
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!items.length) return;

    const timers = {};
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.dataset.id;
          if (!id || id.startsWith("quiz-")) return;

          if (entry.isIntersecting) {
            if (!timers[id]) {
              timers[id] = setTimeout(() => {
                setReadItems((prev) => {
                  if (prev[id]) return prev;
                  const next = { ...prev, [id]: true };
                  localStorage.setItem("readItems", JSON.stringify(next));
                  return next;
                });
              }, 10000);
            }
          } else {
            if (timers[id]) {
              clearTimeout(timers[id]);
              delete timers[id];
            }
          }
        });
      },
      { root: containerRef.current, threshold: 0.6 }
    );

    const cards = containerRef.current.querySelectorAll(".card[data-id]");
    cards.forEach((card) => observer.observe(card));

    return () => {
      observer.disconnect();
      Object.values(timers).forEach(clearTimeout);
    };
  }, [items]);

  const handleSkipQuiz = () => {
    sessionStorage.setItem("quizSkipped", "true");
    setQuizSkipped(true);
    setItems((prev) => prev.filter((item) => item.type !== "quiz"));
  };

  // const handleShare = (id) => {
  //   const shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}`;
  //   navigator.clipboard
  //     .writeText(shareUrl)
  //     .then(() => toast.success("🔗 Link copied to clipboard!"))
  //     .catch(() => toast.error("❌ Could not copy link"));
  // };
  const handleShare = (id) => {
  const shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}`;

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => toast.success("🔗 Link copied to clipboard!"))
      .catch(() => {
        fallbackCopy(shareUrl);
      });
  } else {
    fallbackCopy(shareUrl);
  }
};

const fallbackCopy = (text) => {
  // fallback using prompt (less elegant, but works almost everywhere)
  const copied = window.prompt("Copy this link:", text);
  if (copied !== null) {
    toast.success("🔗 Link ready to copy!");
  } else {
    toast.error("❌ Copy canceled.");
  }
};


  if (loading) return <div className={classes.loading}>Loading…</div>;
  if (!items.length)
    return <div className={classes.loading}>No items to display.</div>;

  return (
  <div
    className={classes.feedContainer}
    ref={containerRef}
    onScroll={onScroll}
  >
    {items.map((item, index) =>
      item.type === "card" ? (
        <div ref={itemRefs.current[index]} key={item.data.id}>
          <Card
            item={item.data}
            vote={votes[item.data.id] || 0}
            isRead={!!readItems[item.data.id]}
            onVote={(val) =>
              setVotes((v) => ({
                ...v,
                [item.data.id]: v[item.data.id] === val ? 0 : val,
              }))
            }
            onShare={handleShare}
            classes={classes}
            // (optional: scroll after vote)
          />
        </div>
      ) : (
        <div ref={itemRefs.current[index]} key={item.data.id}
        style={{ scrollMarginTop: "50px" }}
        >
          {/* <QuizCard
            data={item.data}
            classes={classes}
            onSkip={handleSkipQuiz}
            nextRef={itemRefs.current[index + 1]} // 👈 Pass next ref to QuizCard
          /> */}
          <QuizCard
  data={item.data}
  classes={classes}
  onSkip={handleSkipQuiz}
  nextRef={itemRefs.current[index + 1]}
  containerRef={containerRef} // ✅ pass this prop too
/>

        </div>
      )
    )}

    <div className={`${classes.card} ${classes.endCard}`}>
      <div className="card-content">
        <h2>No More Feed available</h2>
      </div>
    </div>
  </div>
);
}
